import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';



function Calendar({fetchDate, setFetchDate}){
    return(
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker 
                label="Date" 
                value={dayjs(fetchDate)} 
                onChange={(newValue) => setFetchDate(newValue)}
                sx={{
                    margin: 1, 
                    marginTop: 2,
                    '& .MuiPickersInputBase-root': {
                        height: 50,
                    },
                    '& .MuiPickersOutlinedInput-notchedOutline': {
                        borderColor: 'var(--headerfooter-bg-color)',
                        borderWidth: '1px', 
                    },
                    '&:hover .MuiPickersOutlinedInput-notchedOutline': {
                        borderColor: 'var(--headerfooter-bg-color) !important', 
                        borderWidth: '2px',
                    },
                    '&.Mui-focused .MuiPickersOutlinedInput-notchedOutline': {
                        borderColor: 'var(--headerfooter-bg-color) !important', 
                        borderWidth: '2px',
                    },

                    '&.Mui-focused  .MuiInputLabel-root':{
                        color: 'rgba(0, 0, 0, 0.6) !important'
                    },
                    '& .MuiInputBase-input': {
                        color: 'black',
                    },
                    '& .MuiSvgIcon-root': {
                        color: 'var(--headerfooter-bg-color)',
                    },
                }}
            />
        </LocalizationProvider>
    )
}


export default Calendar;